import { c as _c } from "react/compiler-runtime";
import imageUrl from "@/sanity/utilities/imageUrl";
import Image from "@/components/common/image/image";
import { PersonData } from "@/sanity/interfaces";
interface PersonCardProps {
  person: PersonData;
}
const PersonCard = t0 => {
  const $ = _c(13);
  const {
    person
  } = t0;
  let t1;
  if ($[0] !== person.name || $[1] !== person.photo) {
    t1 = person.photo?.asset && <Image src={imageUrl(person.photo.asset).width(520).url()} alt={person.name || "Team member"} width={360} height={360} className="block w-full object-cover" srcSet={`
            ${imageUrl(person.photo.asset).width(520).url()} 520w,
            ${imageUrl(person.photo.asset).width(300).url()} 300w
          `} sizes="(width <= 640px) 520px, 300px" />;
    $[0] = person.name;
    $[1] = person.photo;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== person.name) {
    t2 = <div className="font-bold leading-6 !text-[#00698F]">{person.name}</div>;
    $[3] = person.name;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== person.role) {
    t3 = <div className="mt-1 text-sm text-[#666]">{person.role}</div>;
    $[5] = person.role;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="p-4 text-left">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <div className="overflow-hidden rounded-xl">{t1}{t4}</div>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default PersonCard;